/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { SubscriberDTO } from "../models";
import { SubscriberDTOFromJSON, SubscriberDTOToJSON } from "../models";

export interface SubscribeRequest {
  platformId: number;
  subscriberDTO: SubscriberDTO;
  xRecaptchaToken?: string;
}

/**
 *
 */
export class NewslettersApi extends runtime.BaseAPI {
  /**
   */
  async subscribeRaw(
    requestParameters: SubscribeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling subscribe."
      );
    }

    if (requestParameters.subscriberDTO === null || requestParameters.subscriberDTO === undefined) {
      throw new runtime.RequiredError(
        "subscriberDTO",
        "Required parameter requestParameters.subscriberDTO was null or undefined when calling subscribe."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (requestParameters.xRecaptchaToken !== undefined && requestParameters.xRecaptchaToken !== null) {
      headerParameters["x-recaptcha-token"] = String(requestParameters.xRecaptchaToken);
    }

    const response = await this.request(
      {
        path: `/api/newsletters/subscribe`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SubscriberDTOToJSON(requestParameters.subscriberDTO)
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async subscribe(
    requestParameters: SubscribeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.subscribeRaw(requestParameters, initOverrides);
  }
}
